module.exports = __webpack_public_path__ + "static/media/Wedding_RewardBackground.c9e6e2b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Wedding_RewardBackground.png
// module id = 1363
// module chunks = 3